import type { AdProvider } from '../types'

declare global {
  interface Window {
    adsbygoogle: Record<string, unknown>[]
    __adsenseScriptLoaded?: boolean
  }
}

// Env vars are read at module load — no reactivity needed.
const PUBLISHER_ID = import.meta.env.VITE_ADSENSE_PUBLISHER_ID as string | undefined
const SLOT_ID = import.meta.env.VITE_ADSENSE_INTERSTITIAL_SLOT as string | undefined

export const adsenseBanner: AdProvider = {
  id: 'adsense',
  placement: 'banner',
  load(container, options) {
    if (!PUBLISHER_ID || !SLOT_ID) return

    if (!window.__adsenseScriptLoaded) {
      const script = document.createElement('script')
      script.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${PUBLISHER_ID}`
      script.async = true
      script.crossOrigin = 'anonymous'
      document.head.appendChild(script)
      window.__adsenseScriptLoaded = true
    }

    if (container) {
      const ins = document.createElement('ins')
      ins.className = 'adsbygoogle'
      ins.style.display = 'block'
      ins.dataset.adClient = PUBLISHER_ID
      ins.dataset.adSlot = SLOT_ID
      ins.dataset.adFormat = 'auto'
      ins.dataset.fullWidthResponsive = 'true'
      container.appendChild(ins)
    }

    window.adsbygoogle = window.adsbygoogle || []

    // NPA (non-personalized ads): push { params: { npa: 1 } } before the slot push.
    // We use the push-payload approach (not the ?npa=1 script-src query param) because
    // the query param is a one-time hint at script-load time and cannot be toggled per
    // user after the script is cached. The payload push is Google's official GDPR
    // mechanism (https://support.google.com/adsense/answer/9009582) and applies to
    // subsequent slot pushes on the same page regardless of script load order.
    // Default npa=true (safe default) until Task 5 threads real consent state.
    const npa = options?.npa ?? true
    if (npa) {
      window.adsbygoogle.push({ params: { npa: 1 } })
    }

    window.adsbygoogle.push({})
  },
}
